export * from './directives';
export * from './services';
export { AgmCoreModule } from './core.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@agm/core/index.js
// module id = 647
// module chunks = 0